export class TestModel {
    public TestId:number;
    public TestName:string;
}
